export enum CoreExtensionNames {
  MENTION = "mention",
  UTILITY = "utility",
  CHARACTERCOUNT = "characterCount",
  PARAGRAPH = "paragraph"
}
